import { StyleSheet } from 'aphrodite';

import { CampaignsDisplay } from '../CampaignsDisplay';

export class CampaignsDisplayPartner extends CampaignsDisplay {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/CampaignsDisplayPartner.js